module.exports = __webpack_public_path__ + "static/media/2020.3729c04c.png";